import React from 'react';
import '../css/thankyou.css'
import '../css/patientsForm.css'
import { doctorIconNoMargin, bmsThankyouImage } from '../components/Images';
import { getEnrollSupportEmailMessage } from '../api/enrollApi';

const BMSThankYouPage = () => {
    return (
        <div className='thankyou-section'>
            <div className='thankyou-subsection'>
                <div className='success-info'>
                    <div className='success-message'>
                        <h1>Su solicitud fue <strong>enviada con éxito</strong></h1>
                    </div>
                    <hr className="continue-div" />
                    <div className='icon-container'>
                        <img src={doctorIconNoMargin} alt="doctor-icon" className='icon'/>
                    </div>
                    <div className='success-message'>
                        <h2>
                            <span className='highligted-text'>Gracias por registrarse.</span>
                            {" "}Su información fue guardada correctamente.
                        </h2>
                        <p style={{ marginTop: "1rem", fontSize: "1rem" }}>
                            Nos pondremos en contacto con usted. Si tiene alguna consulta, {getEnrollSupportEmailMessage()}
                        </p>
                    </div>
                </div>
            </div>
            <div className='inner-footer-bar'>
                <hr className="footer-bar" />
            </div>
            <div className='thankyou-subsection'>
                <div className='bms-info-container'>
                    <div className='bms-info'>
                        <div className='bms-message'>
                            <h1>Vamos <span className='highligted-text'>Contigo</span></h1>
                        </div>
                        <div className='bms-message'>
                            <h2>Programa Soporte a <span className='highligted-text'>Pacientes</span></h2>
                        </div>
                        <div className='bms-image-container'>
                            <img src={bmsThankyouImage} alt="Thank you"  className='icon'/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="thankyou-footer">
                <hr className="footer-bar" />
            </div>
        </div>
    );
}

export default BMSThankYouPage;
